import axios from 'axios';
import moment, { weekdays } from 'moment';
import React, { Component } from 'react';
import { Button, Spinner, Table, Row, Col, Dropdown, Badge, Offcanvas, Modal, DropdownButton, ButtonGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { t } from '../../helpers/translation_helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faBook, faGlobe, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { GET, POST } from '../../api';
const ContrastColor = require('contrast-color');

// API URL
const apiURL = process.env.REACT_APP_API_URL;

let controller;

/**
 * Dashboard Timetable
 */
class Timetable2 extends Component {
  // State
  state = {
    timetable: [],
    timetable_periods: [],
    weekdays: [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ],
    selectedDay: moment().format('dddd').toLowerCase(),
    selectedDate: moment().format('YYYY-MM-DD'),
    showFullWeekTT: false,
    fullWeekTT: null,
    fullWeekTTPeriods: [],
    selectedTT: null,
    classTimetableModal: {
      refreshing: false,
      show: false,
      data: [],
      class_theme: null,
      open: (class_theme) => this.setState({
        classTimetableModal: {
          ...this.state.classTimetableModal,
          show: true,
          data: [],
          class_theme,
        }
      }, this.getClassTimetable),
      close: () => this.setState({
        classTimetableModal: {
          ...this.state.classTimetableModal,
          show: false,
          class_theme: null
        }
      })
    }
  };

  /**
   * Component Did Update
   */
  componentDidMount() {
    this.getTimetable();
  }

  /**
   * Component Did Update
   */
  componentDidUpdate(prevProps, prevState) {
    const { selectedDay } = this.state;

    if (prevState.selectedDay !== selectedDay) {

      this.setState({ timetable: null });
      this.getTimetable(selectedDay);
    }


  }

  /**
   * Get Timetable
   * @param {string} dayname Name of the day
   * @param {string} thatDate Date (YYYY-MM-DD)
   */
  getTimetable = async (dayname = moment().format('dddd').toLowerCase()) => {
    const source = axios.CancelToken.source();
    const cancelToken = source.token;
    const { authData } = this.props;
    const { center_id } = authData.centerData;
    const { auth_key } = authData.loginData;

    const fData = new FormData();
    fData.append('center_id', center_id);
    fData.append('dayname', dayname.charAt(0).toUpperCase() + dayname.slice(1));
    fData.append('classes', JSON.stringify(authData.classes));
    fData.append('employee_id', this.props.authData.userData.employee_id);

    if (controller) controller.abort();
    controller = new AbortController();

    try {
      const res = await POST(
        'dashboard/get-timetable',
        fData,
        {
          signal: controller.signal,
        }
      );

      this.setState({
        timetable: res.data.timetable,
        timetable_periods:
          res.data.timetable_periods.length > 0
            ? res.data.timetable_periods
            : [],
        selectedDay: dayname.toLowerCase(),
        ...(res.data.timetable_periods.length > 0 && {
          selectedTT: res.data.timetable_periods[0]
        })
      });
    } catch (err) {
      console.log('err', err)
      if (axios.isCancel(err)) {
        // 
      }
      toast.error(t('Something went wrong while fetching timetable!'));

    }
  };


  getFullWeekTimetable = async () => {

    this.setState({ fullWeekTT: null });

    const source = axios.CancelToken.source();
    const cancelToken = source.token;
    const { authData } = this.props;
    const { center_id } = authData.centerData;
    const { auth_key } = authData.loginData;

    const fData = new FormData();
    fData.append('center_id', center_id);
    fData.append('classes', JSON.stringify(authData.classes));
    fData.append('employee_id', this.props.authData.userData.employee_id);

    if (controller) controller.abort();
    controller = new AbortController();

    try {
      const res = await POST(
        'dashboard/get-complete-timetable',
        fData,
        {
          signal: controller.signal,
        }
      );

      if (res.status == 200) {
        this.setState({
          fullWeekTT: res.data.timetable,
          fullWeekTTPeriods:
            res.data.timetable_periods.length > 0
              ? res.data.timetable_periods
              : [],
        });
      }


    } catch (err) {
      console.log('err', err)
      if (axios.isCancel(err)) {
        // 
      }
      toast.error(t('Something went wrong while fetching timetable!'));

    }
  };

  getClassTimetable = async () => {
    const { selectedClass } = this.props;
    const { class_id, class_theme, agegroup_id } = selectedClass.class;
    this.setState({ classTimetableModal: { ...this.state.classTimetableModal, refreshing: true, data: null } });
    try {
      const res = await GET('dashboard/get-class-timetable', {
        params: {
          class_id,
          class_theme,
          agegroup_id
        }
      });

      this.setState({
        classTimetableModal: {
          ...this.state.classTimetableModal,
          refreshing: false,
          data: res.data.data
        }
      });
      console.log('res', res);
    } catch (err) {
      this.setState({ classTimetableModal: { ...this.state.classTimetableModal, refreshing: false, data: null } });
      console.log('err', err);
    }
  }

  renderPeriods = () => {
    const { weekdays, classTimetableModal } = this.state;
    const { data } = classTimetableModal;
    let weekend_days = this.props.authData.centerData.weekend_days.split(',')

    return weekdays.map((item, index) => {
      console.log('item', item);
      if (!weekend_days.includes(item.toLocaleLowerCase())) {
        const subjects = data[item].map((item, index) => {
          return (
            <td>
              {item.acs_name
                ? (
                  <span
                    className='badge'
                    style={{
                      textTransform: 'uppercase',
                      fontSize: '13px',
                      border: `1px solid ${item.as_color}`,
                      color: item.as_color,
                    }}>
                    {item.acs_name
                    }
                    <br />
                    <small>({item.class_theme})</small>
                  </span>
                ) : (
                  t('FREE')
                )}
            </td>
          );
        });

        return (
          <tr key={index}>
            <td>{item}</td>
            {subjects}
          </tr>
        );
      }
    });
  };

  /**
   * Render Weekdays Buttons
   * @returns {HTMLElement} Outputs the buttons of weekdays
   */
  renderWeekdayButtons = () => {
    const { authData } = this.props;
    const { centerData } = authData;
    const { weekend_days } = centerData;
    const { weekdays, selectedDay } = this.state;

    const weekendDaysArr = (weekend_days || '')
      .split(',')
      .map(day => day.trim().toLowerCase());

    const weekdayButtons = weekdays
      .filter(item => !weekendDaysArr.includes(item.toLowerCase()))
      .map((item, index) => {
        return (
          <Button
            style={{ borderRadius: 15 }}
            key={index}
            variant={selectedDay == item ? 'primary' : 'light'}
            className='text-uppercase me-2'
            onClick={() =>
              this.handleDayDate(
                item,
                moment(moment().startOf('isoweek'))
                  .add(index, 'd')
                  .format('YYYY-MM-DD')
              )
            }
            size='sm'>
            {t(item).substring(0, 3)}
          </Button>
        );
      });

    return weekdayButtons;
  };

  /**
   * Render Timetable Time Fields
   * @returns {HTMLElement} Outputs the th of timetable table header
   */
  renderTimetableTimeFields = (tp_id) => {
    const { timetable } = this.state;

    const THs = [];

    for (var i in timetable) {
      if (tp_id == timetable[i].tp_id) {
        THs.push(
          <th key={i}>
            {moment(timetable[i].time_start, 'HH:mm:ss').format(
              'HH:mm'
            )}{' '}
            -
            {moment(timetable[i].time_end, 'HH:mm:ss').format(
              'HH:mm'
            )}{' '}
            {timetable[i].tp_type_name &&
              <span style={{
                borderColor: timetable[i].tp_type_color,
                borderWidth: 1,
                borderStyle: 'solid',
                color: timetable[i].tp_type_color,
                textTransform: 'uppercase',
                borderRadius: 5,
                paddingInline: 4,
                paddingBlock: 2,
                display: 'inline-block'
              }}>
                {timetable[i].tp_type_name}
              </span>
            }
          </th>
        );
      }
    }

    return THs;
  };

  /**
   * Render Timetable Material Fields
   * @returns {HTMLElement} Outputs the td of timetable table body
   */
  renderTimetableMaterialFields = (tp_id) => {
    // Language Direction
    const { lang_orientation: dir } = this.props.defaultLanguage;
    const { timetable } = this.state;

    const TDs = [];

    for (var i in timetable) {
      if (tp_id == timetable[i].tp_id) {
        TDs.push(
          <td
            key={i}
            style={{
              backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8,
            }}>
            {timetable[i].details.map((item, i) => {
              const cc = new ContrastColor({
                bgColor: item.as_color,
                threshold: 200,
              });
              const defaultFgColor = cc.contrastColor();

              return (
                <div key={i} className='d-flex flex-column mb-1'>
                  <div className='me-1' style={{ backgroundColor: item.as_color, color: defaultFgColor, display: 'inline-block', padding: '5px 10px', borderRadius: 5, marginBottom: 3, }}>
                    <div>{item.acs_name}</div>
                    <div className='mb-1'>{item.class_theme}</div>
                    {item.class_online_url !== null && item.class_online_url !== '' && (
                      <div className='d-grid'>
                        <Button
                          style={{ marginTop: '-3px' }}
                          variant='tertiary'
                          size='sm'
                          title={t('Online Class')}
                          onClick={() =>
                            window.open(
                              item.class_online_url,
                              '_blank',
                              'noopener,noreferrer'
                            )
                          }>
                          <FontAwesomeIcon
                            icon={faGlobe}
                            color={brand_colors[this.props.defaultTheme.theme_id].color8}
                          />
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </td>
        );
      }
    }

    return TDs;

  };

  handleOpenFullWeekTT = () => {
    this.setState({
      showFullWeekTT: true
    });
    this.getFullWeekTimetable();
  }
  handleCloseFullWeekTT = () => {
    this.setState({
      showFullWeekTT: false
    });
  }

  /**
   * Handle Day & Date Selection
   * @param {string} selectedDay Day name of the week
   * @param {string} selectedDate Date (YYYY-MM-DD)
   */
  handleDayDate = (selectedDay, selectedDate) => {
    this.setState({
      selectedDay,
      selectedDate,
    });
  };


  // renderFullWeekTTItem = (day, tp_id, time_start, time_end) => {
  //   const { fullWeekTT } = this.state;

  //   for (var i in fullWeekTT[day]) {
  //     if (
  //       fullWeekTT[day][i].tp_id == tp_id &&
  //       fullWeekTT[day][i].time_start == time_start &&
  //       fullWeekTT[day][i].time_end == time_end
  //     ) {
  //       if (fullWeekTT[day][i].details.length > 0) {

  //         return fullWeekTT[day][i].details.map((item, i) => {
  //           const cc = new ContrastColor({
  //             bgColor: item.as_color,
  //             threshold: 200,
  //           });
  //           const defaultFgColor = cc.contrastColor();
  //           return (<div key={i} className='d-flex flex-column mb-1'>
  //             <div className='me-1' style={{ backgroundColor: item.as_color, color: defaultFgColor, display: 'inline-block', padding: '5px 10px', borderRadius: 5, marginBottom: 3, }}>
  //               <div>{item.acs_name}</div>
  //               <div className='mb-1'>{item.class_theme}</div>
  //               {item.class_online_url !== null && item.class_online_url !== '' && (
  //                 <div className='d-grid'>
  //                   <Button
  //                     style={{ marginTop: '-3px' }}
  //                     variant='tertiary'
  //                     size='sm'
  //                     title={t('Online Class')}
  //                     onClick={() =>
  //                       window.open(
  //                         item.class_online_url,
  //                         '_blank',
  //                         'noopener,noreferrer'
  //                       )
  //                     }>
  //                     <FontAwesomeIcon
  //                       icon={faGlobe}
  //                       color={brand_colors[this.props.defaultTheme.theme_id].color8}
  //                     />
  //                   </Button>
  //                 </div>
  //               )}
  //             </div>
  //           </div>
  //             // <span key={i}>
  //             //     ahmad
  //             //     <span
  //             //       style={{
  //             //         backgroundColor:
  //             //           item.as_color,
  //             //         color: defaultFgColor,
  //             //         display: 'inline-block',
  //             //         padding: '5px 10px',
  //             //         borderRadius: 5,
  //             //         marginBottom: 3,
  //             //       }}>
  //             //       {item.acs_name}
  //             //     </span>{' '}
  //             //     {item.class_online_url !== null && item.class_online_url !== '' && (
  //             //       <Button
  //             //         style={{ marginTop: '-3px' }}
  //             //         variant='tertiary'
  //             //         size='sm'
  //             //         title={t('Online Class')}
  //             //         onClick={() =>
  //             //           window.open(
  //             //             item.class_online_url,
  //             //             '_blank',
  //             //             'noopener,noreferrer'
  //             //           )
  //             //         }>
  //             //         <FontAwesomeIcon
  //             //           icon={faGlobe}
  //             //           color={brand_colors[this.props.defaultTheme.theme_id].color8}
  //             //         />
  //             //       </Button>
  //             //     )}
  //             //     <br />
  //             //   </span>
  //           )
  //         });
  //       }
  //     }
  //   }
  // }

  renderFullWeekTTItem = (day, tp_id, time_start, time_end) => {
    const { fullWeekTT } = this.state;

    for (var i in fullWeekTT[day]) {
      if (
        fullWeekTT[day][i].tp_id == tp_id &&
        fullWeekTT[day][i].time_start == time_start &&
        fullWeekTT[day][i].time_end == time_end
      ) {
        if (fullWeekTT[day][i].details.length > 0) {

          return fullWeekTT[day][i].details.map((item, i) => {
            return (<div key={i} className='d-flex flex-column mb-1'>
              <div className='me-1' style={{ borderColor: item.as_color, borderWidth: 1, borderStyle: 'solid', color: brand_colors[this.props.defaultTheme.theme_id].color9, display: 'inline-block', padding: '5px 10px', borderRadius: 5, marginBottom: 3, }}>
                <div>{item.acs_name}</div>
                <div className='mb-1'>{item.class_theme}</div>
              </div>
            </div>
            )
          });
        } else if (fullWeekTT[day][i].tp_type_name) {
          const ty_type = fullWeekTT[day][i];
          return <span style={{
            display: 'block',
            border: `1px solid ${ty_type.tp_type_color}`,
            color: ty_type.tp_type_color,
            borderRadius: 5,
            padding: '3px 10px',
          }}>{ty_type.tp_type_name}</span>
        }
      }
    }
  }


  /**
   * Render Component
   * @returns {HTMLElement}
   */
  render() {
    // State
    const {
      timetable,
      timetable_periods,
      showFullWeekTT,
      fullWeekTT,
      fullWeekTTPeriods,
      weekdays,
      selectedTT
    } = this.state;
    if (timetable_periods.length <= 0) {
      return null
    }

    const { selectedClass } = this.props;
    const { class_theme } = selectedClass.class;

    // console.log('%cSTATE_TIMETABLE', 'color: orange; font-size: 20px; font-weight: bold;', this.state);


    return (
      <div
        style={{
          background: '#fff',
          borderRadius: 20,
          padding: 15,
          paddingTop: 12
        }}>
        <Row>
          <Col md={'auto'}><h6 className='mb-3'>{t('Timetables')}</h6></Col>
          <Col className='text-end'>
            <Button size='sm' className='me-2' onClick={() => this.state.classTimetableModal.open(class_theme)}>{t('Class Timetable')}</Button>
            <DropdownButton
              as={ButtonGroup}
              size="sm"
              variant="warning"
              title={selectedTT?.tp_name}
              className='me-2'

            >
              {timetable_periods.length == 0 &&
                <Dropdown.Item disabled>{t('No timetables found!')}</Dropdown.Item>
              }
              {timetable_periods.length > 0 && timetable_periods.map((tp_item, tp_index) => (
                <Dropdown.Item
                  key={tp_index}
                  onClick={() => this.setState({ selectedTT: tp_item })}>
                  <span className='d-flex justify-content-between align-items-center'>
                    {tp_item.tp_name}
                    {this.state.selectedTT?.tp_id === tp_item.tp_id && (
                      <FontAwesomeIcon icon={faCheckCircle} color='#48CF48' />
                    )}
                  </span>
                </Dropdown.Item>
              ))}
            </DropdownButton>
            <button style={{
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
            }}
              onClick={() => this.handleOpenFullWeekTT()}>
              <FontAwesomeIcon
                icon={faUpRightFromSquare} color='#538DEE' />
            </button>
          </Col>
        </Row>
        <div className='mb-3 d-flex'>
          {this.renderWeekdayButtons()}
        </div>
        <div style={{
          border: '1px solid #E0E0E0',
          borderRadius: 10,
          overflow: 'hidden',
        }}>
          {timetable && Object.values(timetable)
            .filter(period => this.state.selectedTT && period.tp_id === this.state.selectedTT.tp_id)
            .map((period, idx, arr) => (
              <div key={idx} className='d-flex' style={{
                borderBottom: idx === arr.length - 1 ? 'none' : '1px solid #E0E0E0'
              }}>
                <div style={{ borderRight: '1px solid #E0E0E0', padding: '10px 0', width: 150, textAlign: 'center' }}>{period.time_start.substring(0, 5)} - {period.time_end.substring(0, 5)}
                  {period.tp_type_name &&
                    <>
                      <br />
                      <span style={{
                        border: `1px solid ${period.tp_type_color}`,
                        color: period.tp_type_color,
                        borderRadius: 5,
                        padding: '3px 10px',
                        fontSize: 13
                      }}>{period.tp_type_name}</span>
                    </>
                  }
                </div>
                <div className='d-flex align-items-center'
                  style={{ padding: '10px 20px', background: '#F9F9F9', flex: 1 }}>
                  {/* <pre className='m-0'>{JSON.stringify(period.details, null, 2)}</pre> */}
                  {period.details.length > 0 && period.details.map((detail, d_index) =>
                    <div style={{ flex: 1 }}
                      className='d-flex justify-content-between align-items-center' key={d_index}>
                      <span style={{
                        backgroundColor: detail.as_color,
                        display: 'inline-block',
                        padding: '3px 7px',
                        borderRadius: 5,
                        fontSize: 14,
                      }}>{detail.as_name}</span>
                      <FontAwesomeIcon
                        onClick={() =>
                          window.open(
                            detail.class_online_url,
                            '_blank',
                            'noopener,noreferrer'
                          )
                        }
                        className='cursor-pointer'
                        icon={faGlobe} color='#538DEE' />
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>
        <div
          style={{ padding: 5, borderRadius: 20 }}
          className='dashboard-timetable grey-section mb-3 d-none'>
          <div className='weekday-btns'>
            {this.renderWeekdayButtons()}
            <Button
              variant='warning'
              className='weekday-btn'
              onClick={() => this.handleOpenFullWeekTT()}
              size='sm'>
              {t('Full Week') + ' '}
              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                color={brand_colors[this.props.defaultTheme.theme_id].color8}
              />
            </Button>
          </div>
          {timetable_periods.map((tp_item, tp_index) => (
            <div className='timetable' key={tp_index}>
              <div className='timetable-header' key={tp_index}>
                {tp_item.tp_name}
              </div>
              <div className='dashboard-timetable-table-wrap'>
                <Table className='dashboard-timetable-table text-center'>
                  <thead>
                    <tr>
                      {this.renderTimetableTimeFields(
                        tp_item.tp_id
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {this.renderTimetableMaterialFields(
                        tp_item.tp_id
                      )}
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          ))}
          <Modal className='full-week-tt-popup' show={showFullWeekTT} onHide={this.handleCloseFullWeekTT} size="xl" backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
              <Modal.Title>{t('Full Week Timetables')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {fullWeekTT ? (
                <div>
                  {fullWeekTTPeriods.map((period, periodIndex) => (
                    <div key={periodIndex}>
                      <h5 className='m-0 p-1 text-center' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color12, color: brand_colors[this.props.defaultTheme.theme_id].color8 }}>{period.tp_name}</h5>
                      <Table bordered hover size="sm">
                        <thead>
                          <tr>
                            <th width="150"></th>
                            {period.timetable_period_timings.map((timing, timingIndex) => (
                              <th className='text-center' key={timingIndex}>
                                {moment(timing.time_start, 'HH:mm:ss').format(
                                  'HH:mm'
                                )}{' '}
                                -
                                {moment(timing.time_end, 'HH:mm:ss').format(
                                  'HH:mm'
                                )}{' '}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {weekdays.map((day, dayIndex) => (
                            <tr key={dayIndex}>
                              <td style={{ verticalAlign: 'middle' }}>
                                <strong>{day}</strong>
                              </td>
                              {period.timetable_period_timings.map((timing, timingIndex) => (
                                <td className='text-center' style={{ verticalAlign: 'middle' }} key={timingIndex}>
                                  {this.renderFullWeekTTItem(day, period.tp_id, timing.time_start, timing.time_end)}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center" style={{ position: 'relative', top: '37%' }}>
                  <Spinner
                    animation='grow'
                    variant='dark'
                  />
                </div>
              )}
            </Modal.Body>
          </Modal>
          <Modal className='full-week-tt-popup' show={this.state.classTimetableModal.show} onHide={this.state.classTimetableModal.close} size="xl" backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
              <Modal.Title>{this.state.classTimetableModal?.class_theme + ' ' + t('Timetables')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {(!this.state.classTimetableModal.refreshing && this.state.classTimetableModal.data.Friday)
                ? <Table className='timetable-table text-center hover'>
                  <thead>
                    <tr>
                      <th>{t('Day & Time')}</th>
                      {this.state.classTimetableModal.data.Friday.map(
                        (item, index) => (
                          <th key={index}>
                            {moment(
                              item.time_start,
                              'HH:mm:ss'
                            ).format('HH:mm')}{' '}
                            -{' '}
                            {moment(
                              item.time_end,
                              'HH:mm:ss'
                            ).format('HH:mm')}
                            {' '}
                            {item.tp_type_name &&
                              <span style={{
                                borderColor: item.tp_type_color,
                                borderWidth: 1,
                                borderStyle: 'solid',
                                color: item.tp_type_color,
                                textTransform: 'uppercase',
                                borderRadius: 5,
                                paddingInline: 4,
                                paddingBlock: 2,
                                display: 'inline-block'
                              }}>
                                {item.tp_type_name}
                              </span>
                            }
                          </th>
                        )
                      )}
                    </tr>
                  </thead>
                  <tbody>{this.renderPeriods()}</tbody>
                </Table>
                : <div style={{ height: '120px', flexDirection: 'column', }} className='d-flex justify-content-center align-items-center'>
                  {this.state.classTimetableModal.data?.length <= 0 && this.state.classTimetableModal.refreshing ? (
                    <>
                      <span className='mb-1'>
                        <Spinner animation='grow' variant='dark' />
                      </span>
                      {t('Fetching timetable...')}
                    </>
                  ) : (
                    t('No timetable available!')
                  )}
                </div>
              }
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  languages: state.language.languages,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
  selectedClass: state.selectedClass.data
});

export default connect(mapStateToProps, null)(Timetable2);
